































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Button } from '@/pages/profile/components';
import { Familiarize, Links, Files } from './components';
import { SEND_CHECK_TEXT, CLOSE_FORM_TEXT } from './consts';

@Component({
  components: {
    Familiarize,
    Links,
    Files,
    Button: () => import('@/pages/profile/components/button'),
  },
})
export default class ItemsBlock extends Vue {
  @Prop({ type: Array, default: () => [] })
  readonly links!: Array<any>;

  @Prop({ type: Array, default: () => [] })
  readonly files!: Array<any>;

  @Prop({ type: String, default: '' })
  readonly description!: string;

  openForm: boolean = false;

  get buttonText(): string {
    return this.openForm ? CLOSE_FORM_TEXT : SEND_CHECK_TEXT;
  }

  toggleForm() {
    this.openForm = !this.openForm;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/components/info/compopnents/block/components/itemsblock/ItemsBlock.vue